module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADUSURBVHgB7dXtCcIwEMbxJ+IAHaEjOIKjOIIjZBPdxDqJbtARzisEDMEkhbwdcj8I7YeQ/qGQA5RS/RDRidcMqTjuxWuFVOSgogOE08BSGlhKA0v9RyDfvROvxzbKUMiNw+2sCbXwYRc3JNZUZG6SuLjVbbuiJj7Q5iJTgUGcRQu5yFhgl7g9kb8Cu8blIsPAIXGpSD9waFwskr7Gx0UiKXi3kMCL9FlIEkRaSOQiLZQgJreBf9mZHzPaeBtjFpTgwDu1c8t9/7ijcdk60cYTSik11gdWut+qeYXuQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.png
// module id = aHOS
// module chunks = 0